import NestedTabs, { Option } from "PFComponents/tabs/nested_tabs/nested_tabs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./booking_reports_page.module.scss";
import DemandSection from "./demand_section/demand_section";
import SupplySection from "./supply_section/supply_section";

export enum Filter {
  Supply = "supply",
  Demand = "demand"
}

const BookingsReportsPage = () => {
  const { t } = useTranslation("insights");
  const [selectedFilter, setSelectedFilter] = useState<Filter>(Filter.Supply);
  const handleFilterChange = (id: Filter) => {
    setSelectedFilter(id);
  };

  const filterOptions: Option<Filter>[] = [
    {
      id: Filter.Supply,
      value: t("bookingReports.supply")
    },
    {
      id: Filter.Demand,
      value: t("bookingReports.demand")
    }
  ];

  return (
    <div className={css.wrapper}>
      <NestedTabs<Filter>
        options={filterOptions}
        onChange={handleFilterChange}
        defaultSelected={Filter.Supply}
      />
      {selectedFilter === "supply" && <SupplySection />}
      {selectedFilter === "demand" && <DemandSection />}
    </div>
  );
};

export default BookingsReportsPage;
